import { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useMoveActionsMutation } from "@/store/moves/apis";
import { Move } from "@/types";
import { useToast } from "@/hooks/use-toast";
import { LOST_LEAD_REASONS } from "@/constants";

const SetLeadLost: React.FC<{
  move: Move;
  triggerChildren: React.ReactNode;
  onSuccess?: () => void;
  refetchMove?: () => void;
}> = ({ move, triggerChildren, onSuccess, refetchMove }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [moveActions] = useMoveActionsMutation();
  const { toast } = useToast();

  const handleSetToLost = async (reason: string) => {
    try {
      setIsLoading(true);
      await moveActions({
        id: move.id,
        action: "set_to_lost",
        data: { reason },
      }).unwrap();

      onSuccess?.();

      toast({
        title: "Success",
        description: "Lead marked as lost",
      });

      refetchMove?.();
    } catch (err) {
      console.error("Error setting lead to lost:", err);
      toast({
        title: "Error",
        description: "Failed to mark lead as lost",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>{triggerChildren}</DropdownMenuTrigger>
        <DropdownMenuContent
          align="center"
          className="font-medium border-gray-300"
        >
          {Object.entries(LOST_LEAD_REASONS)
            .sort((a, b) => a[1].localeCompare(b[1]))
            .map(([key, value]) => (
              <DropdownMenuItem
                className="cursor-pointer"
                key={key}
                disabled={isLoading}
                onSelect={() => handleSetToLost(key)}
              >
                {value}
              </DropdownMenuItem>
            ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};

export default SetLeadLost;
